import styled from 'styled-components'
import { Box, Typography } from 'src/components'

export const SectionSAndF = styled(Box)`
    width: 100%;
    height: 195px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background: ${({ theme }) => theme.colors.grewSecond};
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`
export const SectionTitle = styled(Typography)`
    font-family: inherit;
    font-style: normal;
    text-align: center;
    line-height: 32px;

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`
export const ContentForm = styled.form`
    display: flex;
    align-items: center;
    flex-direction: column;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`
export const ContentInput = styled(Box)`
    width: 220px;
    height: 40px;

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 400px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 220px;
        height: 40px;
    }
`
export const ContentButton = styled.button`
    width: 220px;
    height: 40px;
    background: ${({ theme }) => theme.colors.second};
    color: ${({ theme }) => theme.colors.white};
    border: 2px solid ${({ theme }) => theme.colors.second};
    padding: 0 10px;
    position: relative;
    z-index: 1;
    overflow: hidden;
    display: inline-block;
    margin-top: 24px;
    border-radius: 12px;
    :hover {
        color: ${({ theme }) => theme.colors.dark};
        border: 2px solid ${({ theme }) => theme.colors.white};
    }
    :after {
        content: '';
        color: ${({ theme }) => theme.colors.dark};
        background: ${({ theme }) => theme.colors.white};
        border: 2px solid ${({ theme }) => theme.colors.white};
        position: absolute;
        z-index: -1;
        padding: 16px 20px;
        display: block;
        border-radius: 50%;
        left: -50%;
        right: -50%;
        top: -150%;
        bottom: -150%;
        transform: scale(0, 0);
        transition: all 0.4s ease;
    }
    :hover::after {
        transition: all 0.6s ease-out;
        transform: scale(1, 1);
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 400px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 220px;
        height: 40px;
    }
`
